import { resolveCatalogLocale, useAppLocale } from '@/i18n/context';
import { namespaceCopyFor } from '@/i18n/ns';
import questionsCopy from '@/i18n/ns/questions';

/** New asks declare their response language. Stored asks without it retain
 * the interface-language fallback; never guess from question or source text. */
export function useQuestionCopy(language?: string) {
  const appLocale = useAppLocale();
  const locale = resolveCatalogLocale(language ?? appLocale);
  return { locale, copy: namespaceCopyFor(questionsCopy, locale) };
}
